import { createSelector } from 'reselect'
import { SettingsState } from 'src/modules/settings/settings_slice'
import { RootState } from 'src/modules/store'

const selectRaw = (state:RootState):SettingsState => state.settings

const selectSettings = createSelector([selectRaw], (raw) => raw.userSettings)

const selectIsDark = createSelector([selectSettings], (userSettings) => userSettings.theme.isDark)

const selectInitLoading = createSelector([selectRaw], (raw) => Boolean(raw.initLoading))

const selectSaveLoading = createSelector([selectRaw], (raw) => Boolean(raw.saveLoading))

const settingsSelectors = {
  selectInitLoading,
  selectSaveLoading,
  selectSettings,
  selectIsDark,
  selectRaw,
}

export default settingsSelectors
